<style scoped>
</style>

<template>
	<v-form @submit.prevent="do_save">
		<v-card>
			<v-card-title v-if = "payroll_header.id == 0">
				New payroll header
			</v-card-title>
			<v-card-title v-if = "payroll_header.id != 0">
				Edit payroll header
			</v-card-title>
			<v-card-text>
				<v-alert type="error" v-if="errormsg != ''">
					{{errormsg}}
				</v-alert>

				<v-row>
					<v-col cols="12">
						<v-select
							label = "Record type"
							:items = "record_types"
							v-model = "payroll_header.rectype"
							:disabled = "payroll_header.id != 0 && payroll_header.is_used"
							@change="onChange($event)"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" v-if = "payroll_header.id == 0">
						<v-text-field label="Payroll number" disabled v-model="created_on_safe_lbl" />
					</v-col>
					<v-col cols="12" v-if = "payroll_header.id != 0">
						<v-text-field label="Payroll number" disabled v-model="payroll_header.payroll_number" />
					</v-col>
				</v-row>
				<v-row v-if="payroll_header.id == 0">
					<!-- <v-row> -->
					<v-col cols="12">
						<DatePicker
							:isOutlined="true" 
							:isIcon="true"
							:isWebsite="false"
							:lableText="'Start date'"
							:dateInit="start_date_init"
							@date="payroll_header.start_date = $event"
						/>
					</v-col>
				</v-row>
				<v-row v-if="payroll_header.id != 0">
					<v-col cols="12">
						<DateRange 
							:isWebsite="false"
							:clearStartDate="false"
							:clearEndDate="end_date_init.length===0||!has_final_pay"
							:startText="'Start date'"
							:endText="'End date'"
							:dateStartInit="start_date_init"
							:dateEndInit="end_date_init"
							@dateStart="payroll_header.start_date = ($event === null ? '': $event)"
							@dateEnd="onDateEnd($event)"
						/>
					</v-col>
				</v-row>
				<v-row v-if="payroll_header.end_date">
					<v-col cols="12">
						<v-select
							label = "Leave reason"
							:items = "leave_reasons"
							v-model = "payroll_header.left_reason.id"
						/>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<v-btn type="submit" :disabled="can_save">SAVE</v-btn>
				<v-btn :disabled="saving" @click="do_cancel()">CANCEL</v-btn>
			</v-card-actions>
		</v-card>
	</v-form>
</template>

<script>
import DatePicker from "@/components/date/date_picker.vue";
import DateRange from "@/components/date/date_range.vue";
export default {
	props: {
		payroll_header: {
			type: Object,
			default: null
		},
		popup_editors: { // when used in the desktop app, we want to popup a new window so Omnis can catch this.
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			errormsg: '',
			loading_reasons: false,
			loading_flavours: false,
			saving: false,
			rectype_local: this.payroll_header.rectype,
			can_save: true,
			abooktypes: [ 2, 3, 7, 12, 15 ],
			non_performing: false,
			talent_active: false,
			freelancer_active: false,
			base_record_types: [
				{ text: "employee", value: 0, abooktypes: [ 3 ]},
				{ text: "performing artist", value: 1, abooktypes: [ 7, 15 ]},
				{ text: "freelancer/non-performing artist", value: 2, abooktypes: [ 7, 12, 15 ]},
				{ text: "voluntary PAYG", value: 3, abooktypes: [ 2,7,12, 15 ]},
			],
			created_on_safe_lbl: "Created on save",
			leave_reasons: [
				{ text: "None", value: 0 }
			],
			start_date_init: this.payroll_header.start_date,
			end_date_init: this.payroll_header.end_date,
			has_final_pay: this.payroll_header.has_final_pay,
		}
	},
	components: {
		DatePicker,
		DateRange,
	},
	computed: {
		record_types() {
			let types = [];
			let self = this;
			//console.log("is used: ",self.payroll_header.is_used);
			this.base_record_types.forEach(function(type) {
				if (self.payroll_header.id != 0 && self.payroll_header.is_used) {
					if (type.value == self.payroll_header.rectype) {
						types.push(type);
					}
				} else {
					let added = false;

					self.abooktypes.forEach(function(abook_type) {
						if (!added && type.abooktypes.includes(abook_type)) {
							//console.log("abook_type: ",abook_type);
							if (abook_type == 7 || abook_type == 15){
								if (!self.non_performing && type.value == 1 && (self.talent_active || (self.payroll_header.id!=0 && self.payroll_header.rectype == 1))) {
									types.push(type);
									added = true;
								} else if (self.non_performing && type.value == 2 && (self.talent_active || (self.payroll_header.id!=0 && self.payroll_header.rectype == 2))){
									types.push(type);
									added = true;
								} else if (type.value == 3 && (self.talent_active || (self.payroll_header.id!=0 && self.payroll_header.rectype == 3))){
									types.push(type);
									added = true;
								};
							} else if (abook_type == 12 && (self.freelancer_active || (self.payroll_header.id!=0 && (self.payroll_header.rectype == 2 || self.payroll_header.rectype == 3)))) {
								types.push(type);
								added = true;
							
							} else if (abook_type == 3) {
								types.push(type);
								added = true;
							};
							
							
						}
					});
				}
			});

			if (types.length === 1) {
				self.can_save = false;
			} else {
				if (!types.map(type => { return type.value}).includes(this.payroll_header.rectype)) {
					self.can_save = true;
				}
			}

			return types;
		}
	},
	mounted() {
		this.load_reasons();
		this.get_abook_flavours();
	},
	methods: {
		onChange(value) {
			if (value !== this.rectype_local) {
				this.can_save = false;
			}
		},
		load_reasons() {
			let self = this; // make sure we can access this inside of our promisses
			this.loading_reasons = true;

			this.leave_reasons = [
				{ text: "None", value: 0 }
			];

			// load our leave reasons
			axios
				.get("/api/config/payroll/leftreason", {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						let left_reasons = json.data;

						left_reasons.forEach(left_reason => {
							self.leave_reasons.push({
								text: left_reason.desc, value: left_reason.id
							})
						})
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading_reasons = false;
				});
						
		},
		get_abook_flavours() {
			let self = this;
			this.loading_flavours = true;

			if (!this.payroll_header.addressbook_id) {
				this.abooktypes = [];
				return;
			}

			// load our flavours
			axios
				.get("/api/addressbook/" + this.payroll_header.addressbook_id , {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						//console.log(json.data);
						self.non_performing = json.data.non_performing;
						self.talent_active = json.data.talent_active;
						self.freelancer_active = json.data.freelancer_active;
						self.abooktypes = json.data.flavours.split(",").map(function(x) {
							return parseInt(x, 10);
						});

						// console.log(self.abooktypes);
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading_flavours = false;
				});

		},
		do_save() {
			let self = this;
			self.saving = true;
			self.lasterrormsg = "";

			if (this.payroll_header.id) {
				this.payroll_header.update()
					.then(function() {
						self.saving = false;

						if (self.popup_editors) {
							window.open("/close")
						} else {
							// route to new URL once we implement the web interface for this
						}

					})
					.catch(function(reason) {
						self.errormsg = reason;
						self.saving = false;
					})
			} else {
				this.payroll_header.insert()
					.then(function() {
						self.saving = false;
						self.start_date_init = self.payroll_header.start_date;
						if (self.popup_editors) {
							window.open("/close")
						} else {
							// route to new URL once we implement the web interface for this
						}
					})
					.catch(function(reason) {
						self.errormsg = reason;
						self.saving = false;
					})
			}
		},
		do_cancel() {
			if (this.popup_editors) {
				window.open("/close")
			} else {
				// route to new URL once we implement the web interface for this
			}
		},
		onDateEnd(end_date) {
			this.can_save = false;

			if (end_date !== null) {
				this.payroll_header.end_date = (end_date === null ? '': end_date);
			} else {
				if (this.end_date_init.length === 0 || !this.has_final_pay) {
					this.payroll_header.end_date = '';
					this.payroll_header.left_reason.id = 0;
				} else {
					this.payroll_header.end_date = this.end_date_init;
				}
				if (this.has_final_pay && end_date === null) {
					this.can_save = true;
				}
			}
			// console.log('End date ' + this.payroll_header.end_date);
		}
	},

	watch: {
		'payroll_header.addressbook_id': function() {
			this.$nextTick(() => {
				this.get_abook_flavours()
			});
		}
	},
}
</script>
